export function updateTree(deselectAll = false) {
  const treeDom = $('#tl_container');
  const treeObj = treeDom?.jstree?.();
  if (treeObj) {
    treeObj.settings.core.data = window.apm.getTree();
    if (deselectAll) {
      treeObj.deselect_all();
    }
    treeObj.refresh();
  }
}
